/**
 * CE QUE LA CF DE NOTIFICATION A RÉELLEMENT FAIT — dérivation unique côté client
 * =============================================================================
 *
 * `sendLogisticsNotification` n'échoue pas en levant : un envoi dont tous les
 * canaux ont échoué revient normalement, avec `success: false` (#1416). Se
 * contenter d'un `try/catch` fait donc écrire « envoyé » pour un message qui
 * n'est jamais parti.
 *
 * Ce module porte la lecture de cette réponse, une seule fois, pour tous les
 * appelants. Il était né comme méthode de `BackofficeActivityService` (#1416) ;
 * #1358 l'a sorti parce qu'un second appelant en avait besoin — la réponse SAV
 * de `TicketCommunicationService`, qui écrivait une communication sortante et
 * une interaction CRM **sans jamais regarder** ce que la CF avait répondu.
 * Deux lectures indépendantes de la même réponse, c'est la divergence garantie
 * au prochain correctif.
 */

export interface NotificationOutcome {
  result: 'sent' | 'failed';
  errorMsg: string;
  failedChannels: string[];
  /** `status` rendu par la CF : success / partial / failed / skipped. */
  cfStatus?: string;
}

export const NOTIFICATION_SENT: NotificationOutcome = {
  result: 'sent',
  errorMsg: '',
  failedChannels: [],
};

/**
 * Lit la réponse de `sendLogisticsNotification`.
 *
 * `success === false` = échec TOTAL ou PARTIEL : dans les deux cas un
 * destinataire attendu n'a rien reçu. `undefined` (réponse d'une version
 * antérieure de la CF) reste lu comme un succès — on ne transforme pas une
 * absence d'information en échec.
 */
export function readNotificationOutcome(data: any): NotificationOutcome {
  const payload = data ?? {};
  if (payload.success !== false) return NOTIFICATION_SENT;
  return {
    result: 'failed',
    cfStatus: typeof payload.status === 'string' ? payload.status : undefined,
    failedChannels: Array.isArray(payload.failedChannels) ? payload.failedChannels : [],
    errorMsg: payload.message || 'Notification non delivree',
  };
}
